import { User, CheckCircle2, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";
import CloudinaryUpload from "../CloudinaryUpload";

export default function ProfileTab({ user, profile, setProfile, kycDocs, setKycDocs, saveProfile }) {
  const { logoutAll } = useAuth();
  const handleLogoutAll = async () => {
    if (!confirm("Sign out from all devices? You'll need to log in again everywhere.")) return;
    await logoutAll();
    toast.success("Signed out from all devices");
    window.location.href = "/login";
  };
  return (
    <div className="space-y-6" data-testid="profile-form">
      <div className="brut-card p-6 md:p-8 max-w-3xl space-y-4">
      <div className="flex items-center gap-3">
        <User size={20}/><h3 className="font-display font-black text-2xl">Edit profile</h3>
        {user.verified && <span className="brut-tag lime"><CheckCircle2 size={12} className="inline"/> Verified</span>}
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div><label className="label-eyebrow">Name</label><input className="brut-input mt-1" value={profile.name} onChange={e=>setProfile({...profile, name:e.target.value})} data-testid="prof-name"/></div>
        <div><label className="label-eyebrow">Phone</label><input className="brut-input mt-1" value={profile.phone} onChange={e=>setProfile({...profile, phone:e.target.value})} data-testid="prof-phone"/></div>
        <div><label className="label-eyebrow">City</label><input className="brut-input mt-1" value={profile.city} onChange={e=>setProfile({...profile, city:e.target.value})} data-testid="prof-city"/></div>
        {user.role === "student" && <div><label className="label-eyebrow">College</label><input className="brut-input mt-1" value={profile.college} onChange={e=>setProfile({...profile, college:e.target.value})} data-testid="prof-college"/></div>}
        {user.role === "owner" && <>
          <div><label className="label-eyebrow">Business name</label><input className="brut-input mt-1" value={profile.business_name} onChange={e=>setProfile({...profile, business_name:e.target.value})}/></div>
          <div><label className="label-eyebrow">GST number</label><input className="brut-input mt-1" value={profile.gst_number} onChange={e=>setProfile({...profile, gst_number:e.target.value})}/></div>
        </>}
        <div className="md:col-span-2">
          <label className="label-eyebrow">Avatar</label>
          <div className="mt-1">
            <CloudinaryUpload folder="hostro/avatars" value={profile.avatar} onChange={(u)=>setProfile({...profile, avatar: u || ""})} accept="image/*" testId="prof-avatar-upload"/>
          </div>
        </div>
      </div>
      <div>
        <label className="label-eyebrow">KYC documents (Aadhaar / PAN / College ID)</label>
        <div className="mt-1">
          <CloudinaryUpload folder="hostro/kyc" multiple value={kycDocs} onChange={setKycDocs} accept="image/*,application/pdf" resourceType="raw" testId="prof-kyc-upload"/>
        </div>
        <div className="text-xs text-[#4A4A4A] mt-2">KYC Status: <span className="brut-tag white">{user.kyc_status||"pending"}</span></div>
      </div>
      <button onClick={saveProfile} className="brut-btn" data-testid="save-profile-btn">Save profile</button>
      </div>

      <div className="brut-card p-6 max-w-3xl bg-[#FFEAF6]">
        <h3 className="font-display font-black text-xl">Security</h3>
        <p className="text-sm text-[#4A4A4A] mt-1">If you suspect someone else has access to your account, sign out from every device at once.</p>
        <button onClick={handleLogoutAll} className="brut-btn pink mt-3" data-testid="logout-all-btn"><LogOut size={14}/> Sign out everywhere</button>
      </div>
    </div>
  );
}
